import { cn } from "@/lib/utils";
import { useBrandConfig } from "@/utils/useBrandConfig";
import { ReactNode } from "react";
import { ClipLoader } from 'react-spinners';

export interface ButtonProps {
  variant?: 'Rounded' | 'Squared' | 'SoftRounded';
  primary?: boolean;
  backgroundColor?: string;
  size?: 'mobile' | 'small' | 'medium' | 'large' | 'full';
  label: string;
  icon?: ReactNode;
  loading?: boolean;
  labelClass?: string;
  onClick?: () => void;
  type?: "button" | "submit" | "reset" | undefined;
}

const sizeClasses = {
  mobile: 'w-[120px]',
  small: 'w-[160px]',
  medium: 'w-[200px]',
  large: 'w-[230px]',
  full: 'w-full',
};

const variantClasses = {
  rounded: 'rounded-full',
  squared: 'rounded-none',
  softRounded: 'rounded-[14px]',
};

const baseClasses = 'inline-block cursor-pointer leading-[0.8] h-[42px] text-headingXSmall transition-colors duration-200';

export const Button = ({
  primary = false,
  size = 'medium',
  backgroundColor,
  label,
  icon,
  loading = false,
  labelClass,
  type,
  ...props
}: ButtonProps) => {
  let { digitalWalletConfig: { buttonStyle: variant } } = useBrandConfig();

  variant = variant ?? 'rounded';

  const bg = primary
    ? 'bg-black text-white shadow-[inset_0_0_0_1px_rgba(0,0,0,0.15)] hover:bg-[#333]'
    : 'bg-white text-black border border-black hover:bg-[#f0f0f0] shadow-[inset_0_0_0_1px_rgba(0,0,0,0.15)]';

  return (
    <button
      type={type ?? "button"}
      disabled={loading}
      className={`flex flex-row items-center justify-center px-2 ${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${bg}`}
      style={backgroundColor ? { backgroundColor } : {}}
      {...props}
    >
      {loading
        ? <ClipLoader
          color={primary ? "white" : "black"}
          size={24}
        />
        : <>
          {icon && <span className="mr-2">{icon}</span>}
          <p className={cn("text-textMedium", labelClass)}>
            {label}
          </p>
        </>
      }
    </button>
  );
};
